$( document ).ready(function() {
  if($('input[name="option1"]:checked').val() == "Sur-mesure"){
      $('.line-item-property__field').addClass('visible');
      $('.line-item-property__field input').addClass('required');
      $('.line-item-property__field input').prop('required', true);
      $('.shopify-payment-button').addClass('disabled-buy-now-button');
      $('.enter-sizes').addClass('visible');
      if($('#custom-size-hauteur-tronc').val() !== '' && $('#custom-size-tour-poitrine').val() !== '' && $('#custom-size-tour-taille').val() !== '' && $('#custom-size-tour-hanche').val() !== '' && $('#custom-size-longueur-manches').val() !== ''){
        $('.shopify-payment-button').removeClass('disabled-buy-now-button');
        $('.enter-sizes').removeClass('visible');
      }
  }
  
  $('.block-swatch').click(function() {
    if($(this).prev().val() == "Sur-mesure"){
      $('.line-item-property__field').addClass('visible');
      $('.line-item-property__field input').addClass('required');
      $('.line-item-property__field input').prop('required', true);
      if($('#custom-size-hauteur-tronc').val() !== '' && $('#custom-size-tour-poitrine').val() !== '' && $('#custom-size-tour-taille').val() !== '' && $('#custom-size-tour-hanche').val() !== '' && $('#custom-size-longueur-manches').val() !== ''){
        $('.shopify-payment-button').removeClass('disabled-buy-now-button');
        $('.enter-sizes').removeClass('visible');
      } else {
        $('.shopify-payment-button').addClass('disabled-buy-now-button');
        $('.enter-sizes').addClass('visible'); 
      }
    } else {
      $('.line-item-property__field').removeClass('visible');
      $('.line-item-property__field input').removeClass('required');
      $('.line-item-property__field input').prop('required', false);
      $('.shopify-payment-button').removeClass('disabled-buy-now-button');
      $('.enter-sizes').removeClass('visible');
    }
  });
  
  $('.custom-size-input').change(function() {
    if($('#custom-size-hauteur-tronc').val() !== '' && $('#custom-size-tour-poitrine').val() !== '' && $('#custom-size-tour-taille').val() !== '' && $('#custom-size-tour-hanche').val() !== '' && $('#custom-size-longueur-manches').val() !== ''){
      $('.shopify-payment-button').removeClass('disabled-buy-now-button');
      $('.enter-sizes').removeClass('visible');
    } else {
      $('.shopify-payment-button').addClass('disabled-buy-now-button');
      $('.enter-sizes').addClass('visible'); 
    }
  });
});
  